import { render, staticRenderFns } from "./PaginationSelect.vue?vue&type=template&id=4c2a7de6&scoped=true"
import script from "./PaginationSelect.vue?vue&type=script&lang=js"
export * from "./PaginationSelect.vue?vue&type=script&lang=js"
import style0 from "./PaginationSelect.vue?vue&type=style&index=0&id=4c2a7de6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a7de6",
  null
  
)

export default component.exports